import React, { Component } from "react";
import { Table } from "antd";
import { columns, handleMoneyValue, handleMinutesToDate } from "./table-data";
import { columns as columnsPayment } from "../payment-request/data-table";
import { columns as customerPR } from "../../customer/payment-request/data-table";
import { driverlessColumns } from "./driverless/table-data-driverless";
import { driverlessPRColumns } from "./driverless/table-data-driverless-pr";

const keys = [
  "over_time",
  "overnight",
  "over_km_self_drive",
  "CT007",
  "CT008",
  "CT009",
  "CT010",
  "CT011",
  "CT012",
  "CT013",
  "tolls_fee",
  "parking_fee",
  "used_km",
  "used_km_self_drive",
];

export class TotalRow extends Component {
  caculatorTotal = () => {
    const { pageData } = this.props;
    let over_time = 0,
      overnight = 0,
      over_km_self_drive = 0,
      used_km = 0,
      used_km_self_drive = 0;
    let CT010 = 0; // chi phia rua xe
    let CT008 = 0; // chi phi do xe
    let CT009 = 0; // chi phi xam lop
    let CT013 = 0; // chi phi khac
    let CT007 = 0; // chi phi cau duong
    let CT011 = 0; // chi phi luu dem
    let CT012 = 0; // chi phi su co
    let parking_fee = 0;
    let tolls_fee = 0;
    let result = {
      over_time,
      overnight,
      used_km,
      used_km_self_drive,
      over_km_self_drive,
      CT007,
      CT008,
      CT009,
      CT010,
      CT011,
      CT012,
      CT013,
      tolls_fee,
      parking_fee,
    };

    pageData.forEach((element) => {
      keys.forEach((key) => {
        if (!isNaN(element[key])) result[key] += Number(element[key]);
      });
    });

    return {
      ...result,
      over_time: handleMinutesToDate(result.over_time),
      CT007: handleMoneyValue(result.CT007),
      CT008: handleMoneyValue(result.CT008),
      CT009: handleMoneyValue(result.CT009),
      CT010: handleMoneyValue(result.CT010),
      CT011: handleMoneyValue(result.CT011),
      CT012: handleMoneyValue(result.CT012),
      CT013: handleMoneyValue(result.CT013),
      parking_fee: handleMoneyValue(result.parking_fee),
      tolls_fee: handleMoneyValue(result.tolls_fee),
    };
  };

  render() {
    const { is_payment_request, total, isCustomer, isDriverLess, columns: columnsCustom } =
      this.props;
    return (
      <Table.Summary.Row fixed>
        {(columnsCustom
          ? columnsCustom
          : is_payment_request && isDriverLess
          ? driverlessPRColumns()
          : is_payment_request
          ? columnsPayment()
          : isCustomer && isDriverLess
          ? driverlessPRColumns()
          : isCustomer
          ? customerPR(this)
          : isDriverLess
          ? driverlessColumns()
          : columns(this)
        ).map((value, index) => {
          let show = "";
          if (value.key === "week_day") {
            show = "Total";
          } else if (
            is_payment_request &&
            isDriverLess &&
            value.key === "date"
          ) {
            show = "Total";
          } else if (isCustomer && isDriverLess && value.key === "date") {
            show = "Total";
          } else if (keys.includes(value.key)) {
            show = this.caculatorTotal()[value.key];
          } else if (value.key === "over_km") {
            show = total.over_km;
          }
          //  else if (is_payment_request && isDriverLess && value.key === 'used_km') {
          //   show = total.km_traveled;
          // }

          return (
            <Table.Summary.Cell
              index={index}
              key={value.key}
              className={value?.className}
            >
              {show}
            </Table.Summary.Cell>
          );
        })}
      </Table.Summary.Row>
    );
  }
}
